<template>
    <aside
        v-click-outside="closeIconPicker"
        :style="`top: ${iconPickerY}`"
    >
        <ul @click="changeIcon($event)">
            <li
                class="icon-option icon-option--red"
                :class="{ 'icon-option--checked': isIconSelected('marker-red') }"
                data-icon="marker-red"
            />
            <li
                class="icon-option icon-option--yellow"
                :class="{ 'icon-option--checked': isIconSelected('marker-yellow') }"
                data-icon="marker-yellow"
            />
            <li
                class="icon-option icon-option--orange"
                :class="{ 'icon-option--checked': isIconSelected('marker-orange') }"
                data-icon="marker-orange"
            />
            <li
                class="icon-option icon-option--green"
                :class="{ 'icon-option--checked': isIconSelected('marker-green') }"
                data-icon="marker-green"
            />
            <li
                class="icon-option icon-option--blue"
                :class="{ 'icon-option--checked': isIconSelected('marker-blue') }"
                data-icon="marker-blue"
            />
            <li
                class="icon-option icon-option--purple"
                :class="{ 'icon-option--checked': isIconSelected('marker-purple') }"
                data-icon="marker-purple"
            />
        </ul>
    </aside>
</template>

<script>
import Group from '@/models/Group'

export default {
    props: {
        selectedItem: {
            type: Object,
            required: true,
        },

        selectedTarget: {
            type: HTMLElement,
            required: true,
        },
    },

    computed: {
        iconPickerY() {
            const controlCenterTop = document.getElementById('control-center').getBoundingClientRect().top
            const targetTop = this.selectedTarget.getBoundingClientRect().top
            const iconPickerY = targetTop - controlCenterTop - 22
            return `${iconPickerY}px`
        },
    },

    methods: {
        closeIconPicker(event) {
            if (!event.target.classList.contains('map-item__icon')) {
                this.$emit('deselectItem')
            }
        },

        isIconSelected(icon) {
            return this.selectedItem && this.selectedItem.getIcon() === icon
        },

        changeIcon(event) {
            const { target } = event

            if (target.classList.contains('icon-option')) {
                const { icon } = target.dataset
                this.selectedItem.setIcon(icon)

                if (this.selectedItem instanceof Group) {
                    for (let i = 0; i < this.selectedItem.userLocations.length; i++) {
                        this.selectedItem.userLocations[i].setIcon(icon)
                    }
                }

                this.$emit('deselectItem')
            }
        },
    },
}
</script>
